import { Col, Radio, Row, Tag, Checkbox } from 'antd';
//import "antd/dist/antd.css";
import loki from 'lokijs';
import React, { Component } from 'react';
import Select from 'react-select';
import HashLoader from 'react-spinners/HashLoader';
import { CSSGrid, makeResponsive, measureItems } from 'react-stonecutter';
//import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';
import { useShallowEqual } from 'shouldcomponentupdate-children';
import '../App.css';
import relacaoFreguesias from '../data/dados_covid/relacao_BIPZIP_FREGUESIAS.json';
//import camposOriginais from '../etl/covidDB_strapi_cheatsheet.json';
import { convertProjectData } from '../etl/utils';
import arquivoTitle from '../img/arquivo/arquivoTitle.svg';
import pushBackHome from '../img/pushBackHome_fromArquivo.svg';
import { getAllProjects } from '../network/Submissions';
import '../style/arquivoPage.css';
import '../style/card.css';
import '../style/flipCard.css';
import '../style/global.css';
import Card from './Card';

var db = new loki('Example');
var projects = db.addCollection('projects');

const Grid = makeResponsive(measureItems(CSSGrid), {
  //used on the Projects grid
  maxWidth: 1920,
  minPadding: 100
});

const RadioGroup = Radio.Group;
var covidDataArrays = { projects: [] };

const toArray = (
  str,
  separator //transform an sting separated by $ in array
) =>
  str
    .trim()
    .split(separator)
    .map(str => str.trim())
    .filter(str => str.length > 0);

class ArquivoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterFREGUESIA: 'TODOS',
      filterBIPZIP: 'TODOS',
      filterDESTIN: 'TODOS',
      // filterANO: 2017, //Tricky madafaka //HACK
      filterRespostaCovid: 'TODOS',
      filterNECESSITO: 'TODOS',
      filterDISPONIBILIZO: 'TODOS',
      filterTEMA: 'TODOS',
      filterENTIDADES: 'TODOS',
      showArquivo: false,
      query: {},
      showgrid: false
    };

    this.selectedFreguesia = this.selectedFreguesia.bind(this);
    this.selectedRespostasCovid = this.selectedRespostasCovid.bind(this);
    this.selectedBipZip = this.selectedBipZip.bind(this);
    this.selectedDestinatario = this.selectedDestinatario.bind(this);
    // this.selectedANO = this.selectedANO.bind(this);
    this.selectedTema = this.selectedTema.bind(this);
    this.selectedParceiro = this.selectedParceiro.bind(this);
    this.selectedNecessito = this.selectedNecessito.bind(this);
    this.selectedDisponibilizo = this.selectedDisponibilizo.bind(this);

    this.updateProjects = this.updateProjects.bind(this);
    this.queryProjects = this.queryProjects.bind(this);
    this.changeFilter = this.changeFilter.bind(this);
    this.renderTags = this.renderTags.bind(this);
    this.closeTag = this.closeTag.bind(this);

    //this.props.setIsLoading(true);
  }
  /*
  filterField(field) {
    //Method still used to filter all possible fields from old JSON file with "commas" - To be replaced //TODO
    let filter = dataBipZip.projects.reduce(function(arrayFinal, dbProject) {
      if (arrayFinal.indexOf(dbProject[field]) === -1) {
        if (dbProject[field].indexOf(",") !== -1) {
          let separatedValues = dbProject[field].split(",");

          separatedValues.map(value => {
            if (arrayFinal.indexOf(value) === -1) {
              arrayFinal.push(value);
            }
            return;
          });
        } else {
          arrayFinal.push(dbProject[field]);
        }
      }

      return arrayFinal;
    }, []);

    return filter;
  }
*/

  getAllOptions(key) {
    //console.log("getAllOptions for " + key);
    let allPossibleValues = [];

    covidDataArrays.projects.forEach(project => {
      //console.log(project);
      if (project[key]) {
        project[key].forEach(value => {
          if (allPossibleValues.indexOf(value) === -1) {
            allPossibleValues.push(value);
            allPossibleValues.sort();
          }
          // return undefined; //avoid warning
        });
      }
      //return undefined; //avoid warning
    });
    //console.log(allPossibleValues);

    return allPossibleValues;
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  async componentDidMount() {
    this.props.onRef(this); //all method available outside, so we can call SELECTFREGUSIA from map

    ///READ NEW PROJECTS FROM DB
    this.props.setIsLoading(true);
    let allProjects = await getAllProjects();

    //console.log('ALL PROJECTS', allProjects);

    //STRAPI -->FE data conversion

    if (!allProjects || !allProjects.length > 0) {
      allProjects = [];
    }

    let projectsOldFields = convertProjectData(allProjects);
    //converts project data from the "STRAPI MODEL" to the old model used in the first forum urbano

    //console.log('projectFromDB', projectFromDB);
    //console.log('projectsOldFields', projectsOldFields);

    //covidDataArrays.projects = covidDataArrays_beforeMerge.projects.map(

    covidDataArrays.projects = projectsOldFields.map(proposta => {
      //ovidDataArrays.projects = projectsOldFields.map((proposta) => {
      // covidDataArrays.projects = projectsOldFields.map((proposta) => {
      let freguesiasDaProposta = [];
      let populacao = [];
      let nomeBairro = [];
      if (proposta['#Bip/Zip']) {
        proposta['#Bip/Zip'].forEach(numeroBipZip => {
          relacaoFreguesias.bairrosBipZip.forEach(bairro => {
            if (bairro['N BipZip'].toString() === numeroBipZip.toString()) {
              // some FREGUSIAS are more than 1 separated by $
              if (bairro.Freguesia.includes('$')) {
                bairro.Freguesia.concat(toArray(bairro.Freguesia, '$'));
              } else {
                freguesiasDaProposta.push(bairro.Freguesia);
              }
              populacao.push(bairro.População);
              nomeBairro.push(bairro.Bairro);
            }
          });
        });
      } else {
        // console.log(
        //   'proposta ',
        //   proposta['Quem sou Titulo'],
        //   'sem Bipzip',
        //   proposta
        // );
      }

      //add PROMOTORES DATA TO ENTIDADES FIELD - SO ALL CAN BE QUERIED AT THE SAME time:
      if (proposta['EntidadePromotora']) {
        if (proposta['Nome entidades']) {
          // console.log(
          //   'TENHO EntidadePromotora ',
          //   proposta['EntidadePromotora']
          // );
          proposta['Nome entidades'].unshift(proposta['EntidadePromotora']);
        }
      }

      //DELETE REPEATED
      freguesiasDaProposta = freguesiasDaProposta.filter(function(
        item,
        pos,
        self
      ) {
        return self.indexOf(item) == pos;
      });

      proposta['FREGUESIA'] = freguesiasDaProposta;
      proposta['populacao'] = populacao;
      proposta['nomeBairroBipZip'] = nomeBairro;
      return proposta;
    });

    covidDataArrays.projects.sort(function(a, b) {
      //RANDOMIZE PROJECTS
      return 0.5 - Math.random();
    });

    if (projects.data.length === 0) {
      // console.log(covidDataArrays.projects);
      projects.insert(covidDataArrays.projects);
    } //initialliznig the DB - inserting fields on memory

    let fullProjects = await projects.find({});

    let updated = await this.updateProjects();

    let queried = (await this.props.queryResult)
      ? await this.props.queryResult(fullProjects)
      : null;
    //console.log(queried + updated);
    //let test2 = await this.props.queryResult(fullProjects);

    Promise.all([queried, updated]).then(() => {
      //this.props.setIsLoading(false);
      this.props.setIsLoading(false);
    });
  }

  // convertProjectData(allProjects) {
  //   //converts project data from the BE "STRAPI MODEL" to the old model used in the first forum urbano

  //   let convertedData = [];
  //   let projectsOldFields = [];

  //   allProjects.forEach((project) => {
  //     let projectObject = {};
  //     Object.entries(project).forEach(([key, value]) => {
  //       if (Array.isArray(value)) {
  //         //this is an array, inside a project i.e AreasTematicas[]
  //         value.forEach((item) => {
  //           if (!projectObject[key]) {
  //             projectObject[key] = [];
  //           }
  //           projectObject[key].push(item.Valor);
  //         });
  //       } else {
  //         projectObject[key] = value;
  //       }
  //     });
  //     convertedData.push(projectObject);
  //   });

  //   //convert from STRAPI forma to FE format
  //   convertedData.forEach((project, index) => {
  //     let oldFieldsProject = {};
  //     Object.entries(project).forEach(([field, value]) => {
  //       if (camposOriginais.correspondencia_inversa[field]) {
  //         let oldKey = camposOriginais.correspondencia_inversa[field].key;
  //         oldFieldsProject[oldKey] = value;
  //       } else {
  //         console.log('Failed on ' + field);
  //       }
  //     });
  //     projectsOldFields.push(oldFieldsProject);
  //   });

  //   return projectsOldFields;
  // }

  processProjectData(covidDataArrays, projectsOldFields) {}

  async queryProjects() {
    //console.log("building Query...");
    let query = {};

    // var searchRegex = new RegExp(this.state.filterFREGUESIA, "giu");
    // //collection.find({ myField: { $regex: searchRegex } });

    //If filter is empty/unselected then the query must not contain it
    this.state.filterFREGUESIA !== 'TODOS'
      ? (query['FREGUESIA'] = { $contains: this.state.filterFREGUESIA })
      : delete query['FREGUESIA'];

    this.state.filterBIPZIP !== 'TODOS'
      ? (query['nomeBairroBipZip'] = {
          $contains: this.state.filterBIPZIP
        })
      : delete query['nomeBairroBipZip'];

    this.state.filterRespostaCovid !== 'TODOS'
      ? (query['Respostas COVID'] = {
          $contains: this.state.filterRespostaCovid
        })
      : delete query['Respostas COVID'];

    this.state.filterENTIDADES !== 'TODOS'
      ? (query['Nome entidades'] = { $contains: this.state.filterENTIDADES })
      : delete query['Nome entidades'];

    // this.state.filterDESTIN !== "TODOS"
    //   ? (query["DESTINATÁRIOS"] = { $contains: this.state.filterDESTIN })
    //   : delete query["DESTINATÁRIOS"];

    this.state.filterNECESSITO !== 'TODOS'
      ? (query['NECESSITO'] = { $contains: this.state.filterNECESSITO })
      : delete query['NECESSITO'];

    this.state.filterDISPONIBILIZO !== 'TODOS'
      ? (query['DISPONIBILIZO'] = { $contains: this.state.filterDISPONIBILIZO })
      : delete query['DISPONIBILIZO'];
    // this.state.filterANO !== 2017
    //   ? (query["ANO"] = this.state.filterANO)
    //   : delete query["ANO"];

    this.state.filterTEMA !== 'TODOS'
      ? (query['áreas temáticas'] = { $contains: this.state.filterTEMA })
      : delete query['áreas temáticas'];

    this.state.showArquivo
      ? (query['Arquivado'] = this.state.showArquivo)
      : delete query['Arquivado'];

    /*this.state.filterDESTIN
      ? (query["DESTINATÁRIOS"] = { $contains: this.state.filterDESTIN })
      : (query["DESTINATÁRIOS"] = {});
*/

    this.setState({
      //This state will serv to represent as TAG's what is currently FILTERED
      query: query
    });

    //eslint-disable-next-line
    this.props.queryResult
      ? this.props.queryResult(projects.find(query))
      : null;

    // console.log("projects.find(query): ", projects.find(query));
    return await projects.find(query);
  }

  async updateProjects() {
    // console.log('Updating Projects...');

    let test = await this.setState({
      filteredProjects: await this.queryProjects()
    });
    //console.log('this.state.filteredProjects', this.state.filteredProjects);
    this.props.updateListedProjects &&
      this.props.updateListedProjects(this.state.filteredProjects);
    return test;
  }

  closeTag(filter) {
    console.log('Close Tag filter: ' + filter);

    switch (filter) {
      case 'FREGUESIA': {
        this.selectedFreguesia('TODOS');
        break;
      }
      case 'ANO': {
        this.selectedANO(2017);
        break;
      }
      case 'nomeBairroBipZip': {
        this.selectedBipZip('TODOS');
        break;
      }
      case 'Respostas COVID': {
        this.selectedRespostasCovid('TODOS');
        break;
      }
      case 'áreas temáticas': {
        this.selectedTema('TODOS');
        break;
      }
      case 'DESTINATÁRIOS': {
        this.selectedDestinatario('TODOS');
        break;
      }
      case 'RECURSOS': {
        this.selectedDestinatario('TODOS');
        break;
      }
      case 'Nome entidades': {
        this.selectedParceiro('TODOS');
        break;
      }
      case 'DISPONIBILIZO': {
        this.selectedDisponibilizo('TODOS');
        break;
      }
      case 'NECESSITO': {
        this.selectedNecessito('TODOS');
        break;
      }
    }
  }

  selectedParceiro = option => {
    console.log('selectedParceiro:' + option);
    if (
      option !== null &&
      option.label !== null &&
      option.label !== '' &&
      option !== 'TODOS'
    ) {
      this.setState(
        {
          filterENTIDADES: option.label //fuckin dummy
        },
        () => {
          this.updateProjects();
        }
      );
    } else {
      this.setState(
        {
          filterENTIDADES: 'TODOS' //fuckin dummy
        },
        () => {
          this.updateProjects();
        }
      );
    }
  };

  changeFilter(filter, value) {
    //This will replace all functions below. //TODO
    //console.log(value);
    //console.log(filter);
    //console.log(`changed ${filter} to ${that}`);

    this.setState(
      {
        [filter]: value //fuckin dummy
      },
      () => {
        this.updateProjects();
      }
    );
  }

  selectedFreguesia(value) {
    console.log(`selected ${value}`);
    this.setState(
      {
        filterFREGUESIA: value
      },
      () => {
        this.updateProjects();
        //eslint-disable-next-line
        this.props.setSelectedFreguesia //if this component is being used on MAP section, we will need to update the map
          ? this.props.setSelectedFreguesia(value)
          : null;
      }
    );
  }

  selectedRespostasCovid(value) {
    this.setState(
      {
        filterRespostaCovid: value
      },
      () => {
        this.updateProjects();
        //eslint-disable-next-line
        this.props.setSelectedResposta //if this component is being used on MAP section, we will need to update the map
          ? this.props.setSelectedResposta(value)
          : null;
      }
    );
  }
  selectedTema(e) {
    let valueToSearch;

    if (e !== 'TODOS') {
      valueToSearch = e.target.value;
    } else {
      valueToSearch = 'TODOS';
    }
    // console.log("Tematica selected:" + valueToSearch);

    this.setState(
      {
        filterTEMA: valueToSearch
      },
      () => {
        this.updateProjects();
      }
    );
    //console.log(`selected ${valueToSearch}`);
  }
  selectedNecessito(e) {
    let valueToSearch;

    if (e !== 'TODOS') {
      valueToSearch = e.target.value;
    } else {
      valueToSearch = 'TODOS';
    }
    // console.log("Tematica selected:" + valueToSearch);

    this.setState(
      {
        filterNECESSITO: valueToSearch
      },
      () => {
        this.updateProjects();
      }
    );
    //console.log(`selected ${valueToSearch}`);
  }

  selectedDisponibilizo(e) {
    let valueToSearch;

    if (e !== 'TODOS') {
      valueToSearch = e.target.value;
    } else {
      valueToSearch = 'TODOS';
    }
    // console.log("Tematica selected:" + valueToSearch);

    this.setState(
      {
        filterDISPONIBILIZO: valueToSearch
      },
      () => {
        this.updateProjects();
      }
    );
    //console.log(`selected ${valueToSearch}`);
  }

  selectedDestinatario(value) {
    this.setState(
      {
        filterDESTIN: value
      },
      () => {
        this.updateProjects();
      }
    );
    // console.log(`selected ${value}`);
  }

  selectedBipZip(value) {
    this.setState(
      {
        filterBIPZIP: value
      },
      () => {
        this.updateProjects();
      }
    );
    //console.log(`selected ${value}`);
  }

  selectedShowArquivo(value) {
    console.log('showArquivo', this.state.showArquivo);
    this.setState(
      {
        showArquivo: value
      },
      () => {
        this.updateProjects();
      }
    );
    //console.log(`selected ${value}`);
  }

  // selectedANO(value) {
  //   //console.log(`selected ${value}`);
  //   this.setState(
  //     {
  //       filterANO: value,
  //     },
  //     () => {
  //       this.updateProjects();
  //     }
  //   );
  // }

  renderSelectFreguesia() {
    let filter_Freguesias = this.getAllOptions('FREGUESIA');

    filter_Freguesias = filter_Freguesias.map(freg => ({
      label: freg,
      value: freg
    }));

    return (
      <Select
        options={filter_Freguesias}
        // className="locationDropdown"
        isClearable={true}
        placeholder="Selecione Freguesia"
        onChange={clicked => {
          // console.log('E', e);
          if (clicked) {
            this.selectedFreguesia(clicked.value);
          } else {
            this.selectedFreguesia('TODOS');
          }
        }}
        //  value={this.state.filterFREGUESIA}
      >
        {/* <Option className="locationDropdown" value={'TODOS'}>
          TODOS
        </Option>
        {filter_Freguesias.map((fregName, idx) => (
          <Option key={idx} className="locationDropdown" value={fregName}>
            {fregName}
          </Option>
        ))} */}
      </Select>
    );
  }

  renderRespostaCovid() {
    let filterRespostaCovid = this.getAllOptions('Respostas COVID');

    filterRespostaCovid = filterRespostaCovid.map(resposta => ({
      label: resposta,
      value: resposta
    }));
    return (
      <Select
        // className="bipZip_Dropdown"
        options={filterRespostaCovid}
        placeholder="Selecione Resposta..."
        //onChange={this.selectedBipZip}
        onChange={clicked => {
          // console.log('E', e);
          if (clicked) {
            this.selectedRespostasCovid(clicked.value);
          } else {
            this.selectedRespostasCovid('TODOS');
          }
        }}
        isClearable={true}
        // value={this.state.filterBIPZIP}
      />
    );
  }
  //  <AntdSelect
  //         className="locationDropdown"
  //         placeholder="Selecione Modo de fazer"
  //         onChange={this.selectedRespostasCovid}

  //         value={this.state.filterRespostaCovid}
  //       >
  //         <Option className="locationDropdown" value={'TODOS'}>
  //           TODOS
  //         </Option>
  //         {filterRespostaCovid.map((modo, idx) => (
  //           <Option key={idx} className="locationDropdown" value={modo}>
  //             {modo}
  //           </Option>
  //         ))}
  //       </AntdSelect>

  // renderSelectDestinatario() {
  //   let filterDESTIN = this.getAllOptions('DESTINATÁRIOS');
  //   return (
  //     <AntdSelect
  //       className="locationDropdown"
  //       placeholder="Selecione Destinatário"
  //       onChange={this.selectedDestinatario}
  //       value={this.state.filterDESTIN}
  //     >
  //       <Option className="locationDropdown" value={'TODOS'}>
  //         TODOS
  //       </Option>
  //       {filterDESTIN.map((modo, idx) => (
  //         <Option key={idx} className="locationDropdown" value={modo}>
  //           {modo}
  //         </Option>
  //       ))}
  //     </AntdSelect>
  //   );
  // }

  renderSelectBipZip() {
    let filterBIPZIP = this.getAllOptions('nomeBairroBipZip');
    //console.log('filterBIPZIP', filterBIPZIP);

    filterBIPZIP = filterBIPZIP.map(bipzip => ({
      label: bipzip,
      value: bipzip
    }));

    return (
      <Select
        // className="bipZip_Dropdown"
        options={filterBIPZIP}
        placeholder="Selecione BIP/ZIP"
        //onChange={this.selectedBipZip}
        onChange={clicked => {
          // console.log('E', e);
          if (clicked) {
            this.selectedBipZip(clicked.value);
          } else {
            this.selectedBipZip('TODOS');
          }
        }}
        isClearable={true}
        // value={this.state.filterBIPZIP}
      >
        {/* <Option className="locationDropdown" value={'TODOS'}>
          TODOS
        </Option>
        {filterBIPZIP.map((bipZip, idx) => (
          <Option key={idx} className="locationDropdown" value={bipZip}>
            {bipZip}
          </Option>
        ))} */}
      </Select>
    );
  }

  renderParceiroFreeSearch() {
    let entidades = [];
    this.getAllOptions('Nome entidades').map(item =>
      entidades.push({ label: item, value: item })
    );

    //console.log(options2[3]);
    //console.log(filterENTIDADES[3]);

    return (
      <Select
        options={entidades}
        optionHeight={43}
        //onChange={this.selectedParceiro}
        onChange={clicked => {
          // console.log('E', e);
          if (clicked) {
            this.selectedParceiro(clicked);
          } else {
            this.selectedParceiro('TODOS');
          }
        }}
        isClearable={true}
        placeholder="Selecione uma entidade"
        //value={this.state.filterENTIDADES}
      />
      /*
      <AntdSelect
        mode="combobox"
        style={{ width: "100%" }}
        onChange={this.freeSearchParceiro}
        filterOption={false}
        placeholder="Digite Entidade:"
      >
        {filterENTIDADES.map((entidade, idx) => (
          <Option key={idx} className="locationDropdown" value={entidade}>
            {entidade}
          </Option>
        ))}
     </AntdSelect>
*/
    );
  }
  /*
"#Bip/Zip"	"Quem sou"	 "Quem sou Titulo”	"Nome entidades"	"descrição proposta"	"descrição proposta__1"	"info útil"	"objectivo e relevância"	"áreas temáticas"	"Respostas COVID"	"lista acções"	"Como Podemos Ajudar"	"Fonte da Informação"
*/

  renderSelectTema() {
    return (
      <RadioGroup
        className="radioText"
        style={{ textAlign: 'left' }}
        onChange={this.selectedTema}
        defaultValue={'TODOS'}
        value={this.state.filterTEMA}
      >
        <Radio className="smallText" value={'Saúde'}>
          Saúde
        </Radio>
        <br />
        <Radio className="smallText" value={'Participação'}>
          Participação
        </Radio>
        <br />
        <Radio className="smallText" value={'Direitos'}>
          Direitos
        </Radio>
        <br />
        <Radio className="smallText" value={'Intervenção/Apoio Social'}>
          Intervenção/Apoio Social
        </Radio>
        <br />
        <Radio className="smallText" value={'Emprego'}>
          Emprego
        </Radio>
        <br />

        <Radio className="smallText" value={'Habitat'}>
          Habitat
        </Radio>
        <br />

        <Radio className="smallText" value={'Educação'}>
          Educação
        </Radio>
        <br />
        <Radio className="smallText" value={'Cultura'}>
          Cultura
        </Radio>
        <br />

        <Radio className="smallText" value={'TODOS'}>
          <strong>Todos</strong>
        </Radio>
        <br />
      </RadioGroup>
    );
  }

  renderNecessito() {
    return (
      <RadioGroup
        className="radioText"
        style={{ textAlign: 'left' }}
        onChange={this.selectedNecessito}
        defaultValue={'TODOS'}
        value={this.state.filterNECESSITO}
      >
        <Radio className="smallText" value={'Recursos Humanos'}>
          Recursos Humanos
        </Radio>
        <br />
        <Radio className="smallText" value={'Recursos Tecnológicos'}>
          Recursos Tecnológicos
        </Radio>
        <br />
        <Radio className="smallText" value={'Recursos Financeiros'}>
          Recursos Financeiros
        </Radio>
        <br />
        <Radio className="smallText" value={'Serviços'}>
          Serviços
        </Radio>
        <br />
        <Radio className="smallText" value={'Bens Alimentares'}>
          Bens Alimentares
        </Radio>
        <br />
        <Radio className="smallText" value={'Bens não alimentares'}>
          Bens não Alimentares
        </Radio>
        <br />
        <Radio className="smallText" value={'Espaços'}>
          Espaços
        </Radio>
        <br />
        <Radio className="smallText" value={'TODOS'}>
          <strong>Não Específico</strong>
        </Radio>
        <br />
      </RadioGroup>
    );
  }
  renderDisponibilizo() {
    return (
      <RadioGroup
        className="radioText"
        style={{ textAlign: 'left' }}
        onChange={this.selectedDisponibilizo}
        defaultValue={'TODOS'}
        value={this.state.filterDISPONIBILIZO}
      >
        <Radio className="smallText" value={'Recursos Humanos'}>
          Recursos Humanos
        </Radio>
        <br />
        <Radio className="smallText" value={'Recursos Tecnológicos'}>
          Recursos Tecnológicos
        </Radio>
        <br />
        <Radio className="smallText" value={'Recursos Financeiros'}>
          Recursos Financeiros
        </Radio>
        <br />
        <Radio className="smallText" value={'Serviços'}>
          Serviços
        </Radio>
        <br />
        <Radio className="smallText" value={'Bens Alimentares'}>
          Bens Alimentares
        </Radio>
        <br />
        <Radio className="smallText" value={'Bens não alimentares'}>
          Bens não Alimentares
        </Radio>
        <br />
        <Radio className="smallText" value={'Espaços'}>
          Espaços
        </Radio>
        <br />
        <Radio className="smallText" value={'TODOS'}>
          <strong>Não Específico</strong>
        </Radio>
        <br />
      </RadioGroup>
    );
  }

  renderProjectosArquivadosCheckbox() {
    return (
      <div>
        <Checkbox
          // checked={formState[field]}
          onChange={e => {
            console.log(`checked = ${e.target.checked}`);
            this.selectedShowArquivo(e);
          }}
        ></Checkbox>
      </div>
    );
  }
  renderTags() {
    let tags;

    let tagsArray = [];
    let cleanQuery = []; //These will be the TAGs
    Object.keys(this.state.query).map((key, index) => {
      this.state.query[key].$contains
        ? (cleanQuery[key] = this.state.query[key].$contains)
        : (cleanQuery[key] = this.state.query[key]);
    });

    Object.keys(this.state.query).map((key, index) => {
      tagsArray.push(
        <Tag
          closable
          key={key}
          onClose={() => this.closeTag(key)}
          style={{ textTransform: 'capitalize' }}
        >
          {'' + key + ': ' + cleanQuery[key]}
        </Tag>
      );
    });
    //console.log(tagsArray);
    /*  {console.log("KEY: " + key + " " + index)}*/
    if (
      Object.keys(this.state.query).length === 0 &&
      this.state.query.constructor === Object
    ) {
      tags = (
        <div>
          <Tag>Sem filtros aplicados.</Tag>
        </div>
      );
    } else {
      tags = <div> {tagsArray} </div>;
    }
    //console.log(this.state.query);
    return tags;
  }

  render() {
    //let freguesia = db.filter("FREGUESIA").value();

    //  console.log(this.state.filteredProjects);
    // console.log("filterFREGUESIA: ", this.state.filterFREGUESIA);
    if (this.props.isLoading) {
      return (
        <div style={{ height: '100vh', overflow: 'scroll' }}>
          {!this.props.mapLayout && (
            <div className="goBacktoHomeCOL_fromArquivo">
              <a>
                <img
                  className="pageStickRight"
                  onClick={() => this.props.toggleLeft(false)}
                  src={pushBackHome}
                  alt="img"
                />{' '}
              </a>
            </div>
          )}
          <div className="loader">
            <HashLoader
              //className={override}
              sizeUnit={'px'}
              size={60}
              color={'#55c5cf'}
              loading={this.state.loading}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ height: '100vh', overflow: 'scroll' }}>
          {!this.props.mapLayout && (
            <div className="goBacktoHomeCOL_fromArquivo">
              <a>
                <img
                  className="pageStickRight"
                  onClick={() => this.props.toggleLeft(false)}
                  src={pushBackHome}
                  alt="img"
                />{' '}
              </a>
            </div>
          )}

          {/* prettier-ignore */}
          {!this.props.mapLayout && (
            <Row type="flex" justify="center" align="middle">
              <Col
                xs={{ span: 19 }}
                lg={this.props.mapLayout ? { span: 22 } : { span: 7 }}
              >
                {/* if this is being used in MAP, layout is fully different*/}

                <div className="padding" style={{ paddingTop: '50px' }}>
                  <img src={arquivoTitle} alt="img" />
                </div>
              </Col>
            </Row>
          )}
          {/* prettier-ignore */}

          <Row
          //style={{ paddingBottom: "50px" }}
            type="flex"
            justify="center"
            align="top"
          >
            <Col
              className="arquivCol"
              align="left"
              xs={{ span: 19 }}
              lg={this.props.mapLayout ? { span: 22 } : { span: 7 }}
            >
              {/*lg - before -> WORKAROUND to fix layout on map*/}
              <div align="left" className="colunaStyle">
                <div className="colTitle">LOCALIZAÇÃO</div>
              
                <div className="zona"> Freguesia: </div>
                {this.renderSelectFreguesia()}

                <div className="zona"> BIP/ZIP # </div>
                {this.renderSelectBipZip()}

                <div className="colTitle">ENTIDADES</div>

                {this.renderParceiroFreeSearch()}
              </div>

            </Col>
            <Col
              className="arquivCol"
              align="left"
              xs={{ span: 19 }}
              lg={this.props.mapLayout ? { span: 22 } : { span: 7 }}
            >
              {/* <div className="colTitle">ANO</div>
          
            <Slider
              onChange={this.selectedANO}
              max={2017}
              min={2011}
              marks={marks}
              step={null}
              value={this.state.filterANO}
              defaultValue={2017}
            /> */}

              <div className="colTitle">Resposta COVID</div>
              {this.renderRespostaCovid ()}
            </Col>
            <Col
              className="arquivCol"
              align="left"
              xs={{ span: 19 }}
              lg={this.props.mapLayout ? { span: 22 } : { span: 7 }}
            >
              <div className="colTitle">TEMA</div>
              {this.renderSelectTema()}
              {/* <div className="colTitle">RECURSOS</div> */}
              <div className="colTitle">RECURSOS QUE NECESSITO</div>
              {this.renderNecessito()}
              <div className="colTitle">RECURSOS QUE DISPONIBILIZO</div>
              {this.renderDisponibilizo()}
              {/* <div className="colTitle">Ver projectos arquivados</div>
              {this.renderProjectosArquivadosCheckbox()} */}

              {/* <div className="colTitle">Destinatários</div>
            
             {this.renderSelectDestinatario()}  */}
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="filtrosTitle">
                <strong>
                  {this.state.filteredProjects
                    ? this.state.filteredProjects.length
                    : 0}
                </strong>
                projectos
              </div>
            </Col>
          </Row>
          <div
            style={{
              display: 'flex',
              position: 'fixed',
              top: 10,
              left: 100,
              width: 'auto',
              padding: 5,
              height: 'auto',
              zIndex: 1000,
              backgroundColor: '#f7747544'
            }}
          >
            {this.renderTags()}
          </div>

          <Row type="flex" justify="center">
            <Col
              align="center"
              xs={{ span: 19 }}
              lg={this.props.mapLayout ? { span: 23 } : { span: 23 }}
            >
              <Grid
                className={this.props.mapLayout ? 'projectListOnMaps' : null}
                component="ul"
                columns={20}
                columnWidth={220}
                gutterWidth={5}
                gutterHeight={10}
                itemHeight={210}
                duration={800}
                springConfig={{ stiffness: 170, damping: 26 }}
              >
                {this.state.filteredProjects
                  ? this.state.filteredProjects.slice(0, 20).map((
                      proj //Show only 20 cards maximum - avoid lag
                    ) => (
                      <div key={proj['Quem sou']}>
                        <Card
                          selectedResposta={this.state.filterRespostaCovid}
                          title={proj['Quem sou']}
                          project={proj}
                        />
                      </div>
                    ))
                  : null}
              </Grid>
            </Col>
          </Row>
          <br />
        </div>
      );
    }
  }
}

const ArquivoPage_Perform = useShallowEqual(ArquivoPage);

export default ArquivoPage_Perform;

//export default ArquivoPage_Perform;
